import { useEffect, useState } from 'react'
import { Select } from 'antd'
import { getProjectData, getRelationkeyLabel } from 'Services/WeaverUtils'

RelationPicker = ({ mode = "tags", onChange, onSelect, query, rest... }) ->

  [relationsData, setRelationsData] = useState([])

  query ?= new Weaver.Sparql("""
    SELECT DISTINCT ?rels WHERE {
      ?from ?rels ?to
      FILTER(isURI(?to))
    }
  """)

  useEffect( ->
    ( ->
      { rels } = await query.find()
      parsedRels = rels.map((n) ->
        { key: n.id(), name: getRelationkeyLabel(n.id()) }
      )
      setRelationsData(_.uniqBy(parsedRels, 'name'))
    )()
    undefined
  , [])

  filterRelations = (input, { value }) ->
    lcInput = input.toLowerCase()
    (value.toLowerCase().indexOf(lcInput) isnt -1) or
      (getRelationkeyLabel(value).toLowerCase().indexOf(lcInput) isnt -1)

  <Select
    data-testid="relation-picker"
    mode={mode}
    placeholder="Relation key"
    filterOption={filterRelations}
    defaultActiveFirstOption={true}
    onSelect={onSelect}
    onChange={onChange}
    {...rest}
  >
    {
      relationsData.map((item) ->
        <Select.Option key={item.key} value={item.key}>{ item.name }</Select.Option>
      )
    }
  </Select>

export default RelationPicker
